import React from 'react'
import './Insurance.css'
import { useNavigate } from 'react-router-dom';
//import JoinPriorityWaitlistBtn from '../ViralLoops/JoinPriorityWaitlistBtn';
//import BetaWaitlist from '../Beta-Waitlist/BetaWaitlist';

function Insurance(props) {

    const onInitialSubmit = () => {
        props.setShowJoinWaitList(true);
    }
  
    return (
        <>
            <section id="coverages" className="coverage">
                <div className="container-fluid pe-0">
                    <div className="row">
                    
                        <div className="col-xl-6 col-lg-6 col-md-6 px-lg-0 px-3 coverage-heading">
                            <h2>
                                Primary A-rated commercial
                                auto insurance coverages
                            </h2>
                            <p className="sub-head pt-0 mb-3">Peace of mind exclusively available for your fleet</p>

                            <div className="row pt-5">
                                <div className="col-md-1 col-2 ps-0 pe-0">
                                    <img src="/img/state-mandatory.svg" className="img-fluid" width="48" alt="Mandatory Insurance" />
                                </div>
                                <div className="col-md-11 col-10 ps-0">
                                    <h4 className="pb-1 px-lg-3">State Mandatory Liability Insurance</h4>
                                    <p className='px-lg-3 covarege-paragraph'>
                                        Stay compliant and protected with liability insurance  covering bodily injury and
                                        property damage to others.
                                    </p>
                                </div>
                            </div>

                            <div className="row pt-5 pb-lg-3 pb-0">
                                <div className="col-md-1 col-2 ps-0 pe-0 ">
                                    <img src="/img/physical-damage.svg" className="img-fluid" width="48" alt="Physical Damage Insurance" />
                                </div>
                                <div className="col-md-11 col-10 ps-0">
                                    <h4 className="pb-1 px-lg-3">Physical Damage Insurance</h4>
                                    <p className='px-lg-3 covarege-paragraph'>
                                        Protect your vehicle from unexpected damage, including collisions, theft, and natural
                                        disasters.
                                    </p>
                                </div>
                            </div>

                            <div className="row waitlist pb-0">
                                <div className="col-md-12 px-1">
                                    {/* <button type="button" className="btn btn-dark waitlist_popup1" onClick={() =>{
                                     navigate('/?signup=waitlist')
                                    }}>Join Waitlist</button> */}
                                     <button className='btn btn-dark waitlist_popup1' onClick={onInitialSubmit}>Join  Waitlist</button>
                                      {/* <BetaWaitlist btn={true} btnId="join_wait" buttonClass="btn btn-dark waitlist_popup1" buttonText="Join the Waitlist" /> */}
                                    <p className="sub-text">* For qualified vehicles only.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-6 col-md-6 coverage-image">
                        <img src="/img/coverage-logo.svg"  width="48" alt="" className="d-md-block d-none" />
                        <div className="rentid_car">
                        {/* <img src="/img/rentidcar.jpg" /> */}
                        </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="insurance" className="">
                <div className="container">
                    <div className="row align-items-center companies rounded-5 mx-0">
                        <div className="col-xl-5 col-lg-5 col-md-5">
                            <h3 className="mb-3">
                            Insurance Coverage 
                            for Rideshare & Delivery Drivers
                            </h3>
                            <p className="sub-head">Rent confidently to gig-economy drivers</p>
                            <p className="pt-3">
                                  Our insurance coverage ensures that both you and your drivers are protected, allowing you to confidently expand your rental business. Elevate your service and attract  more drivers by offering a secure and reliable  rental experience.
                            </p>
                        </div>

                        <div className="col-xl-7 col-lg-7 col-md-7 text-center company-logo">
                            <div className="row ">
                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/uber.webp" alt="Uber logo, which consists of the word 'uber' written in lowercase black letters on a transparent background.
" />
                                </div>
                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/postmates.webp" alt="A black silhouette of a person in a wheelchair, appearing on a transparent background. The person is sitting, holding the wheelchair's wheels, and is shown from the side view.
" />
                                </div>
                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/instacart.webp" alt="Instacart logo, which includes a stylized orange carrot with two green leaves to the left. The word 'instacart' is written in lowercase, bold letters to the right of the carrot in a green font." />
                                </div>

                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/doordash.webp" alt="Logo for 'DoorDash,' featuring the company name in uppercase red letters with a stylized, red wing symbol to the left of the text. The background is transparent.
" />
                                </div>
                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/lyr.webp" alt="Lyft logo, which consists of the word 'lyft' in bold, lowercase letters and is colored pink." />
                                </div>
                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/ubereats.webp" alt="Uber Eats logo. The word 'Uber' is in black text with the word 'Eats' in bold green text." />
                                </div>

                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/grubhub.webp" alt="Grubhub logo with the company name in bold, red capital letters against a dark background.
" />
                                </div>
                                <div className="col-md-4 col-6 text-center">
                                    <img src="/img/gopuff.webp" alt="GoPuff logo, with the text 'gopuff' displayed in lowercase, bold, sky-blue letters. The font is modern and smooth, maintaining a playful yet professional appearance.
" />
                                </div>
                                <div className="col-md-4 col-12 text-center">
                                    <img src="/img/caviar.webp" alt="word caviar written in all lowercase letters in a bold, orange font on a white background.
" style={{ width: '170px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
            </section>
        </>
    )
}

export default Insurance